export class TorchKpiOpSafetyPerfIndex {
  id: number;
  indexDate: Date;
  ospi: number;
  ospiTarget: number;
  ospiLowerControlLimit: number;
}
